import React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { Image } from "@arctheme-components/elements/Image/Image";

interface TeamPhotoBannerProps {
  settings: {
    section: {
      team_image?: string;
      team_image_mobile?: string;
      image_fit?: "cover" | "contain";
      height_desktop?: number;
      height_mobile?: number;
    };
    mobile_breakpoint?: string;
  };
}

export const TeamPhotoBanner: React.FC<TeamPhotoBannerProps> = ({ settings }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint || "1024px");
  const section = settings.section;

  const imageUrl = isMobile && section.team_image_mobile 
    ? section.team_image_mobile 
    : section.team_image;

  const height = isMobile 
    ? (section.height_mobile || 400) 
    : (section.height_desktop || 500);

  if (!imageUrl) {
    return null;
  }

  return (
    <div 
      className="w-full relative"
      style={{
        height: `${height}px`,
        minHeight: `${height}px`,
      }}
    >
      <Image
        imageUrl={imageUrl}
        alt="Team Photo"
        classes={`w-full h-full object-${section.image_fit || "cover"}`}
      />
    </div>
  );
};

export default TeamPhotoBanner;
